import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Fullpage, Slide } from 'fullpage-react'
import { TransitionGroup } from 'react-transition-group'
import cn from 'classnames'

import { fetchPageIfNeeded, fetchThumbIfNeeded, fetchSiteOptions } from '../actions'
import { DEFAULT_PAGE } from '../reducers/pages'
import { DEFAULT_SITE_OPTIONS } from '../reducers/siteoptions'
import Thumb from '../components/Thumb'
import { SlideNav } from '../components/SlideNav'
import { FadeAbsolute } from '../components/Transitions'
import { SlideBlock } from '../components/Blocks'
import {setHTML} from '../helpers/helpers'

const { changeFullpageSlide } = Fullpage

class Home extends Component {
    constructor(props) {
        super(props)
        this.state = {
          active: 0,
        }
        // this.onSlideChangeEnd = this.onSlideChangeEnd.bind(this)
        this.onSlideChangeStart = this.onSlideChangeStart.bind(this)
    }
    componentWillMount() {
        const { fetchPageIfNeeded } = this.props
        fetchPageIfNeeded('home')
        fetchSiteOptions()
    }
    componentWillUnmount() {
        //fix stupid bug in fullpage-react
        document.querySelector('html').style.overflow = 'initial'
        document.querySelector('body').style.overflow = 'initial'
    }
    onSlideChangeStart(name, props, state, newState) {
        const oldActive = this.state.active
        const sliderState = {
          active: newState.activeSlide
        }
        const updatedState = Object.assign(oldActive, sliderState)
        this.setState(updatedState)
    }
    render() {
        const { page, siteoptions } = this.props
        const { active } = this.state
        const nextSlide = changeFullpageSlide.bind(null, active + 1)

        const slides = page.cmb2._home_feature_metabox._home_feature_group.map( (slide, i) =>
            <Slide key={i}>
                <SlideBlock 
                    actionText={slide.next} 
                    onClick={nextSlide} 
                    title={slide.title} 
                    text={slide.text} 
                    toNext={page.cmb2._home_feature_metabox._home_feature_group.length !== i + 1}
                    center={page.cmb2._home_feature_metabox._home_feature_group.length === i + 1}
                    customAction={page.cmb2._home_feature_metabox._home_feature_group.length === i + 1 && page.cmb2._home_feature_metabox._home_feature_action_link}/>
            </Slide>
        )

        const fullPageOptions = {
            // for mouse/wheel events
            // represents the level of force required to generate a slide change on non-mobile, 10 is default
            scrollSensitivity: 1,
            // for touchStart/touchEnd/mobile scrolling
            // represents the level of force required to generate a slide change on mobile, 10 is default
            touchSensitivity: 2,
            scrollSpeed: 500,
            hideScrollBars: true,
            enableArrowKeys: true,
            resetSlides: true,
            slides: slides,
            activeSlide: this.state.active,
        }

        const homeClass = cn({featured: page.cmb2._home_feature_training_metabox._home_feature_training_show === 'on', scrolled: this.state.active !== 0 })
        return (
            <div id={page.slug} className={homeClass}>
                <TransitionGroup className="transition-fullpage-wrap">
                    <FadeAbsolute key={this.state.active}>
                        <Thumb fullPage={true} backgroundImage={true} thumbid={page.cmb2._home_feature_metabox._home_feature_group[this.state.active].image_id} nextid={page.cmb2._home_feature_metabox._home_feature_group.length > 1 && page.cmb2._home_feature_metabox._home_feature_group.length > this.state.active + 1 && page.cmb2._home_feature_metabox._home_feature_group[this.state.active + 1].image_id} size="fullscreen-bg" />
                    </FadeAbsolute>
                </TransitionGroup>
                <div className="fade overlay"/>
                <Fullpage {...fullPageOptions} onSlideChangeStart={this.onSlideChangeStart} />
                <SlideNav slides={slides} current={this.state.active} setSlide={changeFullpageSlide}/>
                {page.cmb2._home_feature_training_metabox._home_feature_training_show === 'on' && 
                    <SideBar content={page.cmb2._home_feature_training_metabox} />
                }
                {siteoptions.show_external === 'on' &&
                    <ExternalTaqt info={siteoptions}/>
                }
            </div>
                
        )
    }
}

const ExternalTaqt = (props) =>
    <a className="taqt-external" href={props.info.taqt_external_url} target="_blank">
        <span>{props.info.taqt_external}</span>
        <img src={props.info.taqt_external_img} alt={props.info.taqt_external} />
    </a>

const SideBar = (props) =>
    <div className="featured-training">
        {setHTML(props.content._home_feature_training_text)}
    </div>

function mapStateToProps(state, ownProps) {
    const page = state.pages['home'] || state.pages[DEFAULT_PAGE]
    const siteoptions = state.siteoptions['siteoptions'] || state.siteoptions[DEFAULT_SITE_OPTIONS]
    return {
        page: page,
        siteoptions: siteoptions,
    }
}

export default connect(mapStateToProps,{ fetchPageIfNeeded, fetchThumbIfNeeded })(Home)


// WEBPACK FOOTER //
// ./src/pages/Home.js